import { Component } from 'react';

import { Permissions } from '../cordovaPlugins/Permissions';
import { appServices } from '../singletons';

interface PermissionsProviderProps {
  children: (props: Permissions) => JSX.Element;
}

interface PermissionsProviderState extends Permissions {
  isLoading: boolean;
}

class PermissionsProvider extends Component<
  PermissionsProviderProps,
  PermissionsProviderState
> {
  private subscription;
  public state = {
    isLoading: true,
    push: false,
    location: null,
    backgroundRefresh: false,
    camera: false,
  };

  componentDidMount() {
    this.subscription = appServices.permissions$
      .map((permissions) => ({ ...permissions, isLoading: false }))
      .distinctUntilChanged()
      .subscribe((newState) => this.setState(newState));
  }

  componentWillUnmount() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  render() {
    const { isLoading, ...rest } = this.state;
    if (!isLoading) {
      return this.props.children(rest);
    }
    return null;
  }
}

export default PermissionsProvider;
